<template>
  <div>
    <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
    <dialog-stampa
      :show="dialogStampa"
      title="Stampa Etichette"
      confirmText="Stampa"
      cancelText="Annulla"
      :totaleEtichette="totaleEtichette"
      :isStampaEtichette="true"
      :isModuloA4="isModuloA4"
      @dialog-print="onDialogPrint"
      @dialog-cancel="onDialogCancel"
    />
  </div>
</template>
<script>
  import DialogErrore from '@/components/dialogErrore'
  import DialogStampa from '@/components/dialogStampa'
  import etichetteService from '@/services/etichetteService.js'
  import configurazioni from '@/services/configurazioniService.js'

  var modelloFiltri = require('./filtri.json')
  export default {
    components: {
      DialogErrore,
      DialogStampa
    },
    data() {
      return {
        messaggio: '',
        dialogStampa: false,
        dialogErrore: false,
        etichette: [],
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        impostazioniEtichette: null,
        isModuloA4: false,
        sorgente: '', // Vengo da prodotti o movimenti --> ids passati sono articoli o movimenti
        errorTitle: 'Stampa etichette',
        errorMessage: 'E\' necessario selezionare le etichette da stampare'
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
    },
    async mounted() {
      this.impostazioniEtichette = await configurazioni.getConfigurazione('display_generale', 'etichette')
      console.log(this.impostazioniEtichette)
    },
    watch: {
/*       dialogStampa (val) {
        val || this.closePrint()
      } */
    },
    computed:{
      report() {
        const modello = 'base' 
        // const modello = this.context.impostazioni.custom && this.context.impostazioni.custom.benetton ? 'benetton' : 'base' // TODO : da impostazioni
        return modelloFiltri[modello]
      },
      totaleEtichette() {
        const elSel = this.etichette
        if (elSel.length > 0) {
          const totaleAnagrafica = _.uniq(elSel.map(x => x.idpr)).length
          const totaleMovimenti = _.sum(elSel.map(x => x.quantita))
          return { totaleAnagrafica, totaleMovimenti }
        } else {
          return { totaleAnagrafica: 0, totaleMovimenti: 0 }
        }
      }
      /*       totaleEtichette() {
        // let totale = this.usaQtaAnagrafica ? lodash.uniq(this.movimenti.map(x => x.prodotto.codice)).length : lodash.sum(this.movimenti.map(x => x.quantita))
        const raw = this.elSel
        const selezionati = Object.keys(raw).filter(key => raw[key] === true)
        if (selezionati.includes('*** TUTTI ***')) {
          const totale = this.usaQtaAnagrafica ? lodash.uniq(this.movimenti.map(x => x.prodotto.codice)).length : lodash.sum(this.movimenti.map(x => x.quantita))
          return totale
        } else {
          const movimenti = this.movimenti.filter(x => selezionati.includes(x.prodotto.codice))
          const totale = this.usaQtaAnagrafica ? lodash.uniq(movimenti.map(x => x.prodotto.codice)).length : lodash.sum(movimenti.map(x => x.quantita))
          return totale
        }
      } */
    },
    methods: {
      erroreConfirm() {
        this.dialogErrore = false
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      stampaEtichette(etichette, sorgente) {
        // this.usaQtaAnagrafica = usaQtaAnagrafica
        // const raw = this.elSel
        // let selezionati = Object.keys(raw).filter(key => raw[key] === true)
        if (etichette.length === 0) {
          // this.$toast('E\' necessario selezionare i movimenti', { type: 'fail' })
          this.dialogErrore = true
          return
        }
        // this.totaleEtichette = etichette.length
        this.etichette = etichette
        this.sorgente = sorgente
        this.dialogStampa = true
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report, forzaQuantita) {
        this.dialogStampa = false
        try {
          const tipoQuantita = usaQtaAnagrafica ? 'anagrafica' : 'movimento'
          if (this.sorgente === 'documenti') {
            this.sorgente = 'articoli'
            if (tipoQuantita === 'movimento') {
              let elenco = []
              for (let p of this.etichette) {
                const qta = p.quantita
                for (let n = 0; n < qta; n++) {
                  p.quantita = 1
                  elenco.push(p)
                }
              }
              this.etichette = elenco
            }
          }
          
          // let tipoStampa = this.impostazioniEtichette.tipo
          // let report = this.impostazioniEtichette.report
          // await etichetteService.stampaEtichetta(tipoStampa, report, str, this.salta, tipoQuantita)
          const printResult = await etichetteService.stampaEtichetta(tipoStampa, report, this.etichette, salta, tipoQuantita, this.sorgente, forzaQuantita)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }            
        } catch {
        }
      }
    }
  }
</script>
